import { useCallback, useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { connect } from 'react-redux';
import { Popover } from 'react-tiny-popover';
import { RootState } from '../../../@types/RootState';
import { selectorUser } from '../../../lib/selectorUser';
import NavBarUserMenuContent from '../NavBarUserMenuContent/NavBarUserMenuContent';
import styles from './NavBarUser.module.scss';
import { TestClientResetMonitor } from './TestClientResetMonitor';

type NavBarUserProps = ReturnType<typeof mapStateToProps>;

const NavBarUser = ({ user }: NavBarUserProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenMenu = () => {
    setIsOpen(true);
  };

  const handleCloseMenu = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!user) return null;

  return (
    <>
      <TestClientResetMonitor login={user.login ?? undefined} />
      <Popover
        isOpen={isOpen}
        positions={['bottom', 'left']}
        content={<NavBarUserMenuContent handleCloseMenu={handleCloseMenu} />}
        onClickOutside={handleCloseMenu}
      >
        <span onClick={handleOpenMenu} className={styles.wrapper}>
          Olá, {user.usuarioDTO?.firstName} <MdKeyboardArrowDown />
        </span>
      </Popover>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: selectorUser(state),
});

export default connect(mapStateToProps)(NavBarUser);
